import { Login } from "./login";

export function AdminLogin() {
	return <Login mode='admin' />;
}

export default AdminLogin;
